export function getHeader(){
      
    const headers={
      'content-type': 'application/json',
      }
      return headers;
}